import { Plus, Trash2 } from "lucide-react";
import { FactField } from "./FactField";

const PersonField = ({ field, answers, set, partner }) => (
  <div className="sm:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-5">
    {["client", ...(partner ? ["partner"] : [])].map((who) => (
      <FactField
        key={who}
        field={field}
        id={`${field.k}-${who}`}
        label={partner ? `${field.label} — ${who === "client" ? "You" : "Partner"}` : field.label}
        value={answers[`${field.k}.${who}`]}
        onChange={(v) => set(`${field.k}.${who}`, v)}
      />
    ))}
  </div>
);

const ListSection = ({ list, items, onChange }) => {
  const update = (i, k, v) => onChange(items.map((it, j) => (j === i ? { ...it, [k]: v } : it)));
  return (
    <div className="space-y-6">
      {items.map((item, i) => (
        <div key={i} data-testid={`ff-${list.k}-item-${i}`} className="border border-black/10 bg-white/60 p-5 md:p-6">
          <div className="flex items-center justify-between">
            <p className="font-serif text-lg capitalize text-[#111413]">{list.item} {i + 1}</p>
            <button
              type="button"
              data-testid={`ff-${list.k}-remove-${i}`}
              onClick={() => onChange(items.filter((_, j) => j !== i))}
              className="-m-2 inline-flex items-center gap-1.5 p-2 text-[11px] uppercase tracking-[0.12em] text-[#A78558] hover:text-[#8A6A43]"
            >
              <Trash2 size={14} />
              Remove
            </button>
          </div>
          <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-5">
            {list.fields.map((f) => (
              <div key={f.k} className={f.type === "textarea" ? "sm:col-span-2" : ""}>
                <FactField field={f} id={`${list.k}-${i}-${f.k}`} label={f.label} value={item[f.k]} onChange={(v) => update(i, f.k, v)} />
              </div>
            ))}
          </div>
        </div>
      ))}
      <button
        type="button"
        data-testid={`ff-${list.k}-add`}
        onClick={() => onChange([...items, {}])}
        className="inline-flex items-center gap-2 rounded-full border border-[#0A2333]/40 px-5 py-3 text-xs uppercase tracking-[0.15em] text-[#0A2333] transition-colors duration-300 hover:bg-[#0A2333] hover:text-[#F9F8F4]"
      >
        <Plus size={14} />
        Add {items.length ? "another" : "a"} {list.item}
      </button>
    </div>
  );
};

export const FactSection = ({ section, answers, set, partner }) => (
  <section className="border-t border-black/10 pt-8" data-testid={`ff-section-${section.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
    <h2 className="font-serif text-2xl md:text-3xl tracking-tight text-[#111413]">{section.title}</h2>
    <div className="mt-6">
      {section.list ? (
        <ListSection list={section.list} items={answers[section.list.k] || []} onChange={(v) => set(section.list.k, v)} />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-6">
          {section.fields.map((f) =>
            f.person ? (
              <PersonField key={f.k} field={f} answers={answers} set={set} partner={partner} />
            ) : (
              <div key={f.k} className={f.type === "textarea" ? "sm:col-span-2" : ""}>
                <FactField field={f} id={f.k} label={f.label} value={answers[f.k]} onChange={(v) => set(f.k, v)} />
              </div>
            )
          )}
        </div>
      )}
    </div>
  </section>
);
